<template>
  <div class="container" ref="container" :class="{ visible: isVisible}">
    <div class="fr">
      <div class="age-bracket"><i><span>{{ this.date | short }}</span><span>s</span></i></div>
      <div class="battery">
        <battery ref="battery" :percent="batteryPercent" :index="index" />
      </div>
      <div class="counter">
        <timer :date="date" :maxLifeTime="maxLifeTime" ref="timer" />
      </div>
    </div>
    <div class="desc">
      <time-memory :date="date" />
    </div>
  </div>
</template>
<script>
import battery from './battery'
import timer from './timer'
import timeMemory from './timeMemory'

export default {
  name: 'Counter',
  props: ['date', 'sexy', 'maxLifeTime', 'index', 'scroll'],
  data () {
    return {
      time: {
        year: 0,
        month: 0,
        day: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      batteryPercent: 0,
      isVisible: true
    }
  },
  watch: {
    'scroll': {
      handler() {
        this.detectScroll()
      }
    }
  },
  mounted () {
    setTimeout(()=>{
      this.detectScroll()
    })
  },
  methods: {
    detectScroll () {
      const container = this.$refs.container
      const rect = container.getBoundingClientRect()
      const docHeight =  document.documentElement.clientHeight
      this.docHeight = docHeight
      this.bottom = rect.bottom
      if( rect.bottom > 0 && rect.bottom / 1.2 < docHeight ) {
        this.isVisible = false
        this.$refs.battery.initAnimate()
         this.$refs.timer.initAnimate()
      }
    }
  },
   filters: {
      short (val) {
        return val.substring(val.length - 2, val.length)
      }
    },
  components: {
    battery,
    timer,
    timeMemory
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  padding: 35px 0;
  background: #fff;

  &.visible {
    > * {
      opacity: 0;
    }
  }

  > * {
    transition: all .8s ease;
  }

  .fr {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr;
    // grid-row-gap: 10px;
    // grid-column-gap: 10px;
  }

  > div {
    display: flex;
    align-items: center;
  }

  .age-bracket {
    padding: 0 35px;
    justify-content: center;
    
    i {
      span:first-child {
        font-size: 2.2rem;
        margin-right:5px;
        font-weight:200;
      }
      span:last-child {
        font-size: 1.5rem;
        font-weight: 100;
      }
    }
  }

  .battery {
    justify-content: center;
    box-sizing: border-box;

    > svg {
      width: 120px;
    }
  }

  .counter {
    justify-content: center;
    color: gray;

    span:not(:last-child) {
      // position: relative;
      // top: -4px;
      font-size:1.7rem;
      font-style: italic;
      margin: 0 5px;
      color:indianred;
    }
  }

  .desc {
    position: relative;
    z-index: 1;

    &:after {
      display: flex;
      font-size:2rem;
      font-style: italic;
      color: #ececec;
      content: 'Time\'s Memory';
      position: absolute;
      left:0;top:0;
      right:0;bottom:0;
      align-items: center;
      justify-content: center;
      z-index: -1;
    }
  }

}  

@media screen and ( max-width: 1000px) {
  .container {
    display: flex;
    flex-direction: column;
    padding: 15px 0;
  }

  .fr {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 3fr;
    padding: 35px 0;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
  }

  .desc {
    padding-top: 10px;
    border-top: 1px dashed rgb(226, 226, 226);

    &:after {
      font-size: 2rem !important;
    }
  }
}

@media screen and ( max-width: 420px) {
  .container {
    display: flex;
    flex-direction: column;
    

    .age-bracket {
      padding: 0 10px;

      i {
        position: relative;
        top: -5px;

        // span:first-child {
        //   font-size: 2.8rem;
        // }
      }
    }

    .battery {
      svg { width: 60px }
    }

    .counter {
      font-size: .7rem;

      span:not(:last-child) {
        font-size: 1.4rem;
      }

      .time { display: block; }
    }

  }

}
</style>